import { useWorkspaceRightPanelStore } from './useWorkspaceRightPanelStore';

export const useWorkspaceRightPanelOpen = () => useWorkspaceRightPanelStore((state) => state.open);
